module.exports = __webpack_public_path__ + "static/flags/BF-4e18930105215af964556bc7a3b4d0f9.gif";